import Box from '@mui/material/Box';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { captureError } from '../utils/capture-error';
import { AllianceErrorBoundary } from './alliance/error-boundary';
import { SectionErrorScreen } from './alliance/system-screens';

/**
 * Wraps one section (a tab, a panel, an admin page) so a render error there
 * shows the compact "This section didn't load." with Try again, and the rest
 * of the page keeps working. Moving to another page clears the error; key it
 * by tab to clear it when the tab changes.
 *
 * @param dense - Inside a narrow panel
 */
export function SectionErrorBoundary(props: {
  children: React.ReactNode;
  dense?: boolean;
}) {
  // Hooks
  const location = useLocation();

  return (
    <AllianceErrorBoundary
      resetKey={location.pathname}
      onError={(error, errorInfo) =>
        captureError({ data: { error, errorInfo } })
      }
      fallback={({ reset }) => (
        <Box sx={{ p: 2 }}>
          <SectionErrorScreen onRetry={reset} dense={props.dense} />
        </Box>
      )}
    >
      {props.children}
    </AllianceErrorBoundary>
  );
}
